import {Box, Col, Row} from 'components/Grid';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import classNames from 'classnames';
import {ContactLinkList} from 'modules/footer/components/Footer/ContactLinkList';
import {TLinkItem} from 'modules/footer/components/Footer/types';
import {FooterLocation} from 'modules/footer/components/Footer/Location';
import {BottomBlock} from 'modules/footer/components/Footer/BottomBlock';
import {useContactsList} from 'modules/footer/hooks/useContactsList';
import CheersBlock from 'modules/footer/components/Footer/CheersBlock/CheersBlock';

interface IFooterContacts {
    linkList?: TLinkItem[];
    isLocation?: boolean;
}

export const FooterContacts = ({linkList, isLocation}: IFooterContacts) => {
    const contactsList = useContactsList();

    return (
        <div className={style.footerContacts}>
            <Box>
                <Row className={style.cheers}>
                    <Col>
                        <CheersBlock />
                    </Col>
                </Row>
                <Row>
                    <Col className={style.content}>
                        {contactsList.map(({href, text, title, itemClass}, idx) => (
                            <div className={classNames(style.item, itemClass)} key={idx}>
                                <span className={style.title}>{title}</span>
                                <a href={href}>
                                    <Typography className={style.text} variant={'h5'}>
                                        {text}
                                    </Typography>
                                </a>
                            </div>
                        ))}
                        <div className={'d-block-only-lg'}>
                            <CheersBlock />
                        </div>
                        {linkList && <ContactLinkList className={style.desktop} linkList={linkList} />}
                    </Col>
                </Row>
            </Box>
            {linkList && (
                <BottomBlock>
                    <ContactLinkList linkList={linkList} />
                </BottomBlock>
            )}
            {isLocation && (
                <div className={'mobile-hidden-block'}>
                    <BottomBlock>
                        <FooterLocation />
                    </BottomBlock>
                </div>
            )}
        </div>
    );
};
